import React, { useEffect, useState, useRef } from "react";
import { urlConsulta, urlConsultaDet, getString } from "../../utils";
import { useStore } from "../../context";
import "./index.css";
import { httpGet } from "../../servicios";
import PagoCab from "../../models/PagoCab";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import "tabulator-tables/dist/css/tabulator.min.css";

var _ = require("lodash");
const app = require("../../utils/app_es.json");

export default function Dashboard() {
  const { state } = useStore();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const tableRef = useRef(null);
  const tabulatorInstance = useRef(null);

  useEffect(() => {
    setLoading(true);
    httpGet(urlConsulta + sessionStorage.getItem("username"), state.token)
      .then((res) => {
        if (res.cod === 0) {
          if (res.data.error) {
            setError(true);
            return;
          }
          var data = [];
          res.data.map(async (item) => {
            let result = await httpGet(
              urlConsultaDet + item.idSobre.trimEnd(),
              state.token
            );
            let _cab;
            if (result.cod === 0) {
              _cab = new PagoCab(
                item.idSobre.trimEnd(),
                item.moneda,
                item.valorTotal + " " + item.moneda,
                item.formaPago,
                item.nomCli,
                item.fechaProceso,
                item.horaProceso,
                item.condProceso,
                getString(app, item.mensajeProceso.split("-")[0]),
                item.emailPayer,
                item.docPayer,
                item.referencia !== null
                  ? item.referencia.trimEnd()
                  : item.referencia,
                result.data
              );
            } else {
              _cab = new PagoCab(
                item.idSobre.trimEnd(),
                item.moneda,
                item.valorTotal + " " + item.moneda,
                item.formaPago,
                item.nomCli,
                item.fechaProceso,
                item.horaProceso,
                item.condProceso,
                getString(app, item.mensajeProceso.split("-")[0]),
                item.emailPayer,
                item.docPayer,
                item.referencia !== null
                  ? item.referencia.trimEnd()
                  : item.referencia,
                []
              );
            }
            data.push(_cab);
          });
          setTimeout(() => {
            const myOrderedArray = _.sortBy(data, (o) =>
              o.idSobre.trimEnd()
            ).reverse();
            setLoading(false);
            // Build tabulator after data is ready
            if (tableRef.current) {
              if (tabulatorInstance.current) {
                tabulatorInstance.current.destroy();
              }
              tabulatorInstance.current = new Tabulator(tableRef.current, {
                data: myOrderedArray,
                layout: "fitColumns",
                responsiveLayout: "collapse",
                pagination: "local",
                paginationSize: 10,
                paginationSizeSelector: [10, 25, 50, 100],
                movableColumns: false,
                placeholder: "No hay registros para mostrar",
                columns: [
                  {
                    title: "",
                    formatter: "responsiveCollapse",
                    width: 40,
                    minWidth: 40,
                    hozAlign: "center",
                    resizable: false,
                    headerSort: false,
                  },
                  {
                    title: "Referencia",
                    field: "referencia",
                    hozAlign: "center",
                    headerHozAlign: "center",
                    widthGrow: 2,
                  },
                  {
                    title: "Total",
                    field: "valorTotal",
                    hozAlign: "center",
                    headerHozAlign: "center",
                    widthGrow: 1.5,
                  },
                  {
                    title: "Forma Pago",
                    field: "formaPago",
                    hozAlign: "center",
                    headerHozAlign: "center",
                    widthGrow: 1.5,
                  },
                  {
                    title: "Fecha de pago",
                    field: "fechaProceso",
                    hozAlign: "center",
                    headerHozAlign: "center",
                    widthGrow: 2,
                    formatter: function (cell) {
                      var d = cell.getRow().getData();
                      return d.fechaProceso + " " + d.horaProceso;
                    },
                  },
                  {
                    title: "Estado",
                    field: "mensajeProceso",
                    hozAlign: "center",
                    headerHozAlign: "center",
                    widthGrow: 2,
                    formatter: function (cell) {
                      var val = cell.getValue();
                      var color = "#1565c0";
                      var bg = "#e3f2fd";
                      if (
                        val &&
                        (val.toLowerCase().includes("aprobad") ||
                          val.toLowerCase().includes("approved"))
                      ) {
                        color = "#1b5e20";
                        bg = "#e8f5e9";
                      } else if (
                        val &&
                        (val.toLowerCase().includes("rechaz") ||
                          val.toLowerCase().includes("reject") ||
                          val.toLowerCase().includes("fallid"))
                      ) {
                        color = "#b71c1c";
                        bg = "#ffebee";
                      } else if (
                        val &&
                        val.toLowerCase().includes("pendiente")
                      ) {
                        color = "#e65100";
                        bg = "#fff3e0";
                      }
                      return (
                        '<span style="display:inline-block;padding:4px 12px;border-radius:50px;font-size:0.8rem;font-weight:600;background:' +
                        bg +
                        ";color:" +
                        color +
                        '">' +
                        (val || "-") +
                        "</span>"
                      );
                    },
                  },
                ],
                rowFormatter: function (row) {
                  var data = row.getData();
                  if (data.detalle && data.detalle.length > 0) {
                    var holderEl = document.createElement("div");
                    holderEl.style.padding = "12px 20px";
                    holderEl.style.background = "#f8f9fb";
                    holderEl.style.borderTop = "1px solid #e0e3e8";

                    var headerEl = document.createElement("div");
                    headerEl.style.fontWeight = "700";
                    headerEl.style.fontSize = "0.9rem";
                    headerEl.style.marginBottom = "8px";
                    headerEl.style.color = "#0d1b3e";
                    headerEl.textContent = "Detalle de Pagos";
                    holderEl.appendChild(headerEl);

                    var tableEl = document.createElement("table");
                    tableEl.style.width = "100%";
                    tableEl.style.borderCollapse = "collapse";
                    tableEl.style.fontSize = "0.85rem";

                    var thead =
                      "<thead><tr style='background:#e8edf3;color:#0d1b3e;'>" +
                      "<th style='padding:8px 12px;text-align:left;border-bottom:2px solid #d0d5dd;'>Cod. Est</th>" +
                      "<th style='padding:8px 12px;text-align:left;border-bottom:2px solid #d0d5dd;'>Nombres</th>" +
                      "<th style='padding:8px 12px;text-align:left;border-bottom:2px solid #d0d5dd;'>Cod. Rubro</th>" +
                      "<th style='padding:8px 12px;text-align:left;border-bottom:2px solid #d0d5dd;'>Rubro</th>" +
                      "<th style='padding:8px 12px;text-align:right;border-bottom:2px solid #d0d5dd;'>Valor</th>" +
                      "</tr></thead>";

                    var tbody = "<tbody>";
                    data.detalle.forEach(function (det, i) {
                      var bgColor = i % 2 === 0 ? "#fff" : "#f4f6f8";
                      tbody +=
                        "<tr style='background:" +
                        bgColor +
                        ";'>" +
                        "<td style='padding:6px 12px;border-bottom:1px solid #eee;'>" +
                        (det.codEst ? det.codEst.trimEnd() : "") +
                        "</td>" +
                        "<td style='padding:6px 12px;border-bottom:1px solid #eee;'>" +
                        (det.nomEst ? det.nomEst.trimEnd() : "") +
                        "</td>" +
                        "<td style='padding:6px 12px;border-bottom:1px solid #eee;'>" +
                        (det.codRub || "") +
                        "</td>" +
                        "<td style='padding:6px 12px;border-bottom:1px solid #eee;'>" +
                        (det.dscRub || "") +
                        "</td>" +
                        "<td style='padding:6px 12px;border-bottom:1px solid #eee;text-align:right;font-weight:600;'>$" +
                        (det.valorProcc || "0.00") +
                        "</td>" +
                        "</tr>";
                    });
                    tbody += "</tbody>";

                    tableEl.innerHTML = thead + tbody;
                    holderEl.appendChild(tableEl);
                    row.getElement().appendChild(holderEl);
                  }
                },
              });
            }
          }, 2500);
        } else {
          setError(true);
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setLoading(false);
        console.log("Error:", err);
      });
  }, [state]);

  // Cleanup tabulator on unmount
  useEffect(() => {
    return () => {
      if (tabulatorInstance.current) {
        tabulatorInstance.current.destroy();
      }
    };
  }, []);

  if (loading) {
    return (
      <div className="modern-spinner fade-in">
        <div className="spinner-ring"></div>
        <span>Cargando historial de pagos...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="modern-card slide-in-up">
        <div className="modern-alert modern-alert-error">
          <span style={{ fontSize: "1.3rem" }}>⚠️</span>
          <div>
            <strong>Error al cargar datos</strong>
            <br />
            Hubo un error al traer los datos —{" "}
            <a href="/pension/pagos" className="modern-link">
              Reintentar
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="table-modern-wrapper slide-in-up">
      <div className="table-modern-toolbar">
        <h3>📊 Historial de Pagos</h3>
      </div>
      <div ref={tableRef}></div>
    </div>
  );
}
